export default "__VITE_ASSET__DvBNOSsg__"